import React from 'react';
import { useAppSelector } from 'hooks';
import ReactSelect from 'react-select';

import { InputProps } from '../props';

interface ComponentProps extends InputProps {
  ignorePlaceholder?: boolean;
  /** Visible label for the control. Also what names it to assistive technology. */
  label?: string;
}

interface Option {
  value: string | number;
  label: string;
}

const MultiSelect: React.FC<ComponentProps> = ({
  id,
  label,
  value,
  placeholder,
  ignorePlaceholder = false,
  disabled = false,
  options,
  selectorOptions,
  setFieldValue,
  className,
}) => {
  let selectOptions: Option[] = [];
  if (options) {
    selectOptions = options.map(({ id, name }) => ({ value: id, label: name }));
  } else if (selectorOptions) {
    const rows = useAppSelector(selectorOptions);
    selectOptions = rows.map(({ id, name }) => ({ value: id, label: name }));
  }

  // react-select renders its own inner input with a generated id, so `htmlFor={id}` would point at
  // the wrapper and leave the control itself unlabelled. `inputId` is what makes the association
  // real, and the aria-label covers a caller that gives no visible label.
  const inputId = `${id}-input`;

  return (
    <>
      {label && (
        <label className="form-label" htmlFor={inputId}>
          {label}
        </label>
      )}
      <ReactSelect
        isMulti
        closeMenuOnSelect={false}
        id={id}
        inputId={inputId}
        aria-label={label ?? placeholder}
        name={id}
        value={selectOptions.filter((option) => value?.includes(option.value))}
        isDisabled={disabled}
        options={selectOptions}
        className={className}
        classNamePrefix={'form-input-multi-select'}
        onChange={(options) =>
          setFieldValue &&
          setFieldValue(
            id,
            options.map((option) => option.value),
          )
        }
        placeholder={!ignorePlaceholder ? placeholder : undefined}
      />
    </>
  );
};

export default MultiSelect;
